module.exports = __webpack_public_path__ + "static/logo-ld-logo-on-light@3x-c51430774f7912a4fd5fd5a743e87291.png";